module.exports = __webpack_public_path__ + "static/media/Wristband.ca7d943e.jpg";